exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".W5gu92BU0X34Va-CkMKgv{position:absolute;bottom:5%;left:5%}", ""]);

// exports
exports.locals = {
	"icon": "W5gu92BU0X34Va-CkMKgv",
	"icon": "W5gu92BU0X34Va-CkMKgv"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&camelCase!./~/postcss-loader!./src/styles/GameSounds.css
// module id = 477
// module chunks = 0